import './JournalSavedList.scss'

import { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { ROUTE_ACTIVITIES_JOURNALING_ALL } from '../../../common/helpers/Paths'
import {
  getUserJournals,
  getUserJournalsByID
} from '../../../common/api/Practices'
import { useParams } from 'react-router-dom'
import JournalListGroup from '../JournalListGroup'
import Loading from '../../../../templates/Loading'

export default function JournalSavedList({ setHeaderTitle, setReturnPath }) {
  const [isLoading, setIsLoading] = useState(true)
  const [journalData, setJournalData] = useState([])

  const { journalingId } = useParams()

  useEffect(() => {
    if (journalData.length > 0) return

    setHeaderTitle('Journal List')
    setReturnPath(ROUTE_ACTIVITIES_JOURNALING_ALL)
    ;(async function getUserJournalsAsync() {
      const response = journalingId
        ? await getUserJournalsByID(journalingId)
        : await getUserJournals()
      setJournalData(response || [])
      setIsLoading(false)
    })()
  }, [setHeaderTitle, setReturnPath, journalingId, isLoading, journalData])

  return (
    <Container className='journaling-saved-list-container'>
      <Loading isLoaded={isLoading} loadingClass='h-100'>
        <JournalListGroup journalData={journalData} />
      </Loading>
    </Container>
  )
}
